import { atomFamily } from "recoil";

import { IRideDto } from "../../dto";

export const ridesJourneyAF = atomFamily<IRideDto[] | undefined, number>({
  key: "ridesJourneyAF",
  default: undefined,
});
